import { create } from "zustand";

// Per-sheet view preferences: collapse states, resume zoom, and split panes.
// Module state (not context) so values survive per-candidacy tab remounts and
// focus mode can snapshot/restore them; UserSheetProvider resets it whenever a
// sheet opens.
interface UserSheetViewStore {
  isActivityRailCollapsed: boolean;
  // True from a location save until the refetched candidacy-info lands, so the
  // commute metric can spin across both the mutation and the refetch.
  isCommuteRefreshing: boolean;
  isResumesCollapsed: boolean;
  // undefined until the staffer adjusts zoom; readers fall back to their own
  // split-aware default.
  resumeZoom?: number;
  // Additional tab panes beyond the primary one; non-empty means split view.
  splitTabValues: string[];
  reset: () => void;
  setIsActivityRailCollapsed: (isCollapsed: boolean) => void;
  setIsCommuteRefreshing: (isRefreshing: boolean) => void;
  setIsResumesCollapsed: (isCollapsed: boolean) => void;
  setResumeZoom: (zoom: number | undefined) => void;
  setSplitTabValues: (splitTabValues: string[]) => void;
}

const initialState = {
  isActivityRailCollapsed: false,
  isCommuteRefreshing: false,
  isResumesCollapsed: false,
  resumeZoom: undefined,
  splitTabValues: [],
};

export const userSheetViewStore = create<UserSheetViewStore>()((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setIsActivityRailCollapsed: (isCollapsed) => {
    set({ isActivityRailCollapsed: isCollapsed });
  },
  setIsCommuteRefreshing: (isRefreshing) => {
    set({ isCommuteRefreshing: isRefreshing });
  },
  setIsResumesCollapsed: (isCollapsed) => {
    set({ isResumesCollapsed: isCollapsed });
  },
  setResumeZoom: (zoom) => {
    set({ resumeZoom: zoom });
  },
  setSplitTabValues: (splitTabValues) => {
    set({ splitTabValues });
  },
}));
